<template>
  <div class="animated fadeIn">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-5"
        />
      </b-col>
    </b-row>
    <div v-if="!loading">
      <component-header
        title="Create Commission"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="true"
        @back-press="$router.push('/setup/commission')"
      />
      <ValidationObserver v-slot="{ invalid }" ref="observer">
        <b-row>
          <b-col>
            <b-card>
              <b-row>
                <b-col md="4">
                  <label class="label">Commission Rule Name</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Rule Name"
                  >
                    <input
                      type="text"
                      placeholder="Enter Rule Name"
                      class="form-control"
                      v-model="commissionRuleName"
                      required
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>

                <b-col md="4">
                  <label class="label">Commission Rule Type</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Rule Type"
                  >
                    <ebSelect
                      id="commissionRuleType"
                      label="text"
                      v-model="commissionRuleType"
                      :options="commissionRuleTypeOption"
                      placeholder="Select Rule Type"
                      class="b-2"
                    ></ebSelect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label class="label">Event Type</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Event Type"
                  >
                    <ebSelect
                      id="eventtype"
                      label="text"
                      v-model="eventtype"
                      :options="eventTypeOption"
                      placeholder="Select event Type"
                    ></ebSelect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label class="label"> Applicable To </label>
                  <br />
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Applicable To"
                  >
                    <ebSelect
                      id="applicableTo"
                      label="text"
                      v-model="applicableTo"
                      :options="applicableToOption"
                      placeholder="Select Applicable To"
                    ></ebSelect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label class="label"> Applied On </label>
                  <br />
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Commission Applied On"
                  >
                    <ebSelect
                      id="appliedOn"
                      label="text"
                      v-model="appliedon"
                      :options="appliedOnOption"
                      placeholder="Select Applied On"
                    ></ebSelect>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label class="label">Commission value Percentage</label>
                      <!-- <br />
                      <b-form-radio
                        v-model="selected"
                        :aria-describedby="ariaDescribedby"
                        name="some-radios"
                        value="A"
                        >Percentage</b-form-radio
                      >
                      <b-form-radio
                        v-model="selected"
                        :aria-describedby="ariaDescribedby"
                        name="some-radios"
                        value="B"
                        >Amount</b-form-radio
                      > -->

                      <ValidationProvider
                        rules="required|between:0,100"
                        v-slot="{ errors }"
                        name="Commission value Percentage"
                      >
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="`Enter Value`"
                          v-model="commissionValue"
                          required
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-col>
                </b-row>
              <b-row>
                <b-col md="4">
                  <label class="label">Charge Code</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Charge Code"
                  >
                    <input
                      type="text"
                      placeholder="Enter Charge Code"
                      class="form-control"
                      v-model="chargeCode"
                      required
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </b-card>
            <div class="text-center">
              <button
                type="submit"
                @click="submitCommissionRule"
                class="btn btn-primary mr-1 mb-3"
                :disabled="invalid"
              >
                Submit
              </button>
            </div>
          </b-col>
        </b-row>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import cInput from "@/components/Common/CustomInput";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "CommissionRuleCreate",
  components: {
    ebSelect,
    ebButton,
    ValidationProvider,
    ValidationObserver,
    cInput,
    ComponentHeader,
    AtomSpinner,
  },

  data() {
    return {
      commissionRuleName: "",
      commissionRuleType: "",
      ariaDescribedby: "",
      commissionValue: "",
      eventtype: "",
      appliedon: "",
      chargeCode: "",
      commissionRuleTypeOption: [
        { value: "BASEMENT", text: "Basement" },
        { value: "GROUND", text: "Ground" },
        { value: "ORDER", text: "Order" },
        { value: "ITEM", text: "Item" },
      ],
      applicableTo: "",
      applicableToOption: [
        { value: "PARTNER", text: "Partner" },
        { value: "TENANT", text: "Tenant" },
        { value: "SELLER", text: "Seller" },
        { value: "DELIVERY_AGENT", text: "Delivery Agent" },
        { value: "DISTRIBUTOR", text: "Distributor" },
      ],
      appliedOnOption: [
        { value: "ORDER_AMOUNT", text: "Order Amount" },
        { value: "PAYMENT", text: "Payment" },
        { value: "INVOICE_AMOUNT", text: "Invoice Amount" },
        { value: "DELIVERY_COST", text: "Delivery Cost" },
      ],
      eventTypeOption: [
        { text: "Order-Fulfilled", value: "ORDER_FULFILLED" },
        { text: "Payment-Success", value: "PAYMENT_SUCCESS" },
        { value: "INVOICE_SUCCESS", text: "Invoice-Success" },
        // { value: "DISTRIBUTOR", text: "Distributor" }
      ],
    };
  },
  methods: {
    isValid() {
      const isValid = this.$refs.observer.validate();
      this.$emit("isValid", isValid);
      return isValid;
    },
    async submitCommissionRule() {
      const isValid = await this.isValid();

      if (!isValid) return;
      if (
        this.commissionRuleName &&
        this.commissionRuleType.value &&
        this.commissionValue &&
        this.applicableTo.value
      ) {
        let userCommissionRate = this.commissionValue / 100;
        let userInfoData = JSON.parse(sessionStorage.getItem("userLogin"));
        let payload = {
          ruleName: this.commissionRuleName,
          ruleType: this.commissionRuleType.value
            ? this.commissionRuleType.value
            : "",
          eventType: this.eventtype.value ? this.eventtype.value : "",
          chargeCode: this.chargeCode,
          commission: {
            applicableTo: this.applicableTo.value
              ? this.applicableTo.value
              : "",
            appliedOn: this.appliedon.value ? this.appliedon.value : "",
            rate: userCommissionRate.toFixed(2),
          },
        };

        await this.$store
          .dispatch("commission/createCommissionRule", payload)
          .then((result) => {
            this.$swal({
              title: "Successfull",
              text: "Commission Rule Created Successfully!",
              type: "success",
            });
            this.$router.push("/setup/commission");
          })
          .catch((err) => {
            this.$swal({
              title: "Sorry",
              text: "Unable to Create Commission Rule",
              type: "error",
            });
          });
      } else {
        this.$swal({
          title: "Error",
          text: "Select All Fields",
          type: "error",
        });
      }
    },
  },
};
</script>
<style>
.label {
  font-family: "Lato";
  font-weight: bold;
}
</style>
